import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, from, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { TaxSuiteAntivirusService } from '../services/common/tax-suite-antivirus.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FileUploadAntivirusInterceptor implements HttpInterceptor {
  private uploadRecords: { [userId: string]: number[] } = {};
  private rateLimit = 5; // Max uploads per minute
  private atrioRateLimit = 71;

  constructor(private antivirusService: TaxSuiteAntivirusService, private router: Router) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.body instanceof FormData) {
      const files: File[] = [];
      request.body.forEach((value) => {
        if (value instanceof File) {
          files.push(value);
        }
      });

      const userId = localStorage.getItem('idToken');
      const isAtrioRoute = this.router.url.includes('/atrio/');

      if (files.length > 0) {
        if (!userId && environment.envType != 'local') {

          console.error('User ID token is missing.');
        } else if (
          userId
          && this.isRateLimited(userId, isAtrioRoute)
        ) {
          return throwError(() => ({
            status: 429,
            error: {
              statusCode: 429,
              message:
                'Límite de carga de archivos excedido. Por favor, inténtalo de nuevo más tarde.',
              type: 'FILE',
            },
          }));
        }

        return from(this.antivirusService.executeMultiple(files)).pipe(
          switchMap((validationResult) => {
            console.log(
              'File Interceptor validating File before sending. Result:',
              validationResult
            );

            if (!validationResult.isValid) {
              return throwError(() => ({
                status: 400,
                error: {
                  statusCode: 400,
                  message:
                    'El archivo subido podría contener malware. Por favor, asegúrate de que proviene de una fuente confiable.',
                  type: 'FILE',
                },
              }));
            }
            return next.handle(request);
          }),
          catchError((error: HttpErrorResponse) => {
            const errorMessage =
              error.error?.message ||
              'Hubo un error desconocido al subir el archivo';
            return throwError(() => ({
              status: error.status || 500,
              error: {
                statusCode: error.status || 500,
                message: errorMessage,
                type: 'FILE',
              },
            }));
          })
        );
      }
    }

    return next.handle(request);
  }

  private isRateLimited(userId: string, isAtrioRoute: boolean): boolean {
    const now = Date.now();
    const oneMinuteAgo = now - 60 * 1000;
    const scope = isAtrioRoute ? 'atrio' : 'default';
    const recordsKey = `${userId}:${scope}`;
    const limit = isAtrioRoute ? this.atrioRateLimit : this.rateLimit;

    // Remove timestamps older than one minute
    this.uploadRecords[recordsKey] =
      this.uploadRecords[recordsKey]?.filter(
        (timestamp) => timestamp > oneMinuteAgo
      ) || [];

    // Check if the user has exceeded the limit
    if (this.uploadRecords[recordsKey].length < limit) {
      this.uploadRecords[recordsKey].push(now);
      return false; // Not rate limited
    }

    return true; // Rate limit exceeded
  }
}
